import { GroupCount } from 'src/models';
export const fiterList = [{
  label: 'Last 24h',
  id: GroupCount.Time_24_hours
}, {
  label: '7 days',
  id: GroupCount.Time_7_days
}, {
  label: '30 days',
  id: GroupCount.Time_30_days
}, {
  label: 'All',
  id: GroupCount.Time_All
}];